import React from 'react';

/**
 * Placeholder do painel de Configurações enquanto o chunk lazy carrega.
 */
export const SettingsPanelSkeleton: React.FC = () => (
  <div
    className="fixed inset-0 z-50 flex bg-slate-900/20 backdrop-blur-sm animate-pulse"
    aria-busy="true"
    aria-label="Carregando configurações"
  >
    <div className="ml-auto h-full w-full max-w-2xl bg-white shadow-2xl flex">
      <div className="w-44 border-r border-slate-100 p-3 space-y-2">
        {Array.from({ length: 8 }, (_, i) => (
          <div key={i} className="h-8 bg-slate-100 rounded-lg" />
        ))}
      </div>
      <div className="flex-1 p-6 space-y-4">
        <div className="h-5 bg-slate-200 rounded w-48" />
        <div className="h-3 bg-slate-100 rounded w-64" />
        <div className="grid grid-cols-2 gap-3 pt-4">
          {Array.from({ length: 6 }, (_, i) => (
            <div key={i} className="h-20 bg-slate-100 rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  </div>
);
